module.exports = "../images/cabin-6-person-3.jpg?v=58e94f4";